import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `Pedido/descargarPlantillaExcelPedidosCuartesa`, method: 'GET', body: null, token: token})
}
